import { render } from "./material-tree-list.vue?vue&type=template&id=d7f4e830&ts=true"
import script from "./material-tree-list.vue?vue&type=script&lang=ts"
export * from "./material-tree-list.vue?vue&type=script&lang=ts"

import "./material-tree-list.vue?vue&type=style&index=0&id=d7f4e830&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__